"use strict";
//Burger menu
var btn = document.querySelector(".burger");
var menu = document.querySelector(".menu__ul");
var bgDark = document.querySelector(".menu__bgdark");
var container = document.querySelector(".container")

btn.addEventListener("click", function (e) {
  btn.classList.toggle("open");
  menu.classList.toggle("expanded");
  bgDark.classList.toggle("expanded");
  container.classList.toggle("expanded");

});

// Header qui se cache lorsque lorsque l'utilisateur scroll une certaine portion de px (200px)
let oldScrollY = 0;
let header = document.querySelector(".header");
let offsetY = 200;


window.addEventListener("scroll", (e) =>{
    if(oldScrollY > window.scrollY
        || offsetY > window.scrollY){
        header.classList.remove("hidden");
    }else{
        header.classList.add("hidden");
    }
    oldScrollY = window.scrollY;
});

//Module 3: Selection de box que l'on aime, change de couleur pour dire qu'on l'a selectionné, puis s'enregistre dans le localstorage
// au reload de la page, nous pouvons toujours retrouver les box qu'on a sélectionné
// Code venant de garith.be & MovieWishList
const triggers = document.querySelectorAll(".wishlist__el");
for (let i = 0; i < triggers.length; i++) {
  // au chargement de la page, on remet si nécessaire la class wishlist__el--selected     
  if (isInWishlist(triggers[i].getAttribute("data-id"))) {
    triggers[i].classList.add("wishlist__el--selected");
  }
  // Au click ...
  triggers[i].addEventListener("click", (e) => {
    // On récupère l'attribut data-id de l'élément qui vient d'être cliqué.
    let id = e.currentTarget.getAttribute("data-id");
    // Si l'élément ne fait pas partie de la wishlist
    if (!isInWishlist(id)) {
      // On l'ajoute l'élément dans la liste
      addToWishlist(id);
      // ... et on lui ajoute la classe wishlist__el--selected
      e.currentTarget.classList.add("wishlist__el--selected");
    } else {
      // On enlève l'élément de la wishlist
      removeFromWishlist(id);
      // On lui enléve la classe wishlist__el--selected
      e.currentTarget.classList.remove("wishlist__el--selected");
    }
  });
}













const like = document.querySelectorAll(".icon--like");
for (let i = 0; i < like.length; i++) {
  if (isInlike(like[i].getAttribute("data-id"))) {
    like[i].classList.add("icon--likeCheck");
  }
  like[i].addEventListener("click", (e) => {
    let idtwo = e.currentTarget.getAttribute("data-id");
    if (!isInlike(id)) {
      addToLike(id);
      e.currentTarget.classList.add("icon--likeCheck");
    } else {
      removeFromLike(id);
      e.currentTarget.classList.remove("icon--likeCheck");
    }
  });
}
// Fonction qui permet d'ajouter un id à la wishlist
function addToWishlist(id) {
  let wishlist = getWishlist();
  if (!isInWishlist(id)) {
    wishlist.push(id);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }
}

function addToLike(id) {
  let like = getLike();
  if (!isInlike(id)) {
    like.push(id);
    localStorage.setItem("like", JSON.stringify(like));
  }
}




// Fonction qui permet d'enlever un id de la wishlist
function removeFromWishlist(id) {
  let wishlist = getWishlist();
  let updatedList = wishlist.filter((value) => { return value != id });
  localStorage.setItem("wishlist", JSON.stringify(updatedList));
}


function removeFromLike(id) {
  let like = getWishlist();
  let updatedListTwo = like.filter((value) => { return value != id });
  localStorage.setItem("like", JSON.stringify(updatedListTwo));
}






// Fonction qui permet de vérifier si un id est dans la wishlist
function isInWishlist(id) {
  let wishlist = getWishlist();
  let element = wishlist.find((value) => { return value == id });
  return element !== undefined;
}


function isInlike(id) {
  let like = getWishlist();
  let elementTwo = like.find((value) => { return value == id });
  return elementTwo !== undefined;
}





// Retourne la wishlist sous la forme d'un tableau
function getWishlist() {
  let wishlistJSON = localStorage.getItem("wishlist");
  let wishlist = [];
  if (wishlistJSON === null) {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  } else {
    wishlist = JSON.parse(wishlistJSON);
  }
  return wishlist;
}


function getLike() {
  let likeJson = localStorage.getItem("like");
  let like = [];
  if (likeJson === null) {
    localStorage.setItem("like", JSON.stringify(like));
  } else {
    return like;
  }
}







//smooth scroll
const target = document.getElementById('sectionOne'),
  button = document.getElementById('buttonScroll');


button.addEventListener('click', function () {
  target.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
    inline: 'nearest'
  });

  // Because scrollIntoView doesn't have callback.
  setTimeout(function () {
    window.location.hash = '#sectionOne';
  }, 1000);
});
//source: https://www.creativejuiz.fr/blog/tutoriels/saviez-vous-scrollintoview-js-pour-defiler-vers-element
